import styled from "styled-components";

const MatchPredictionsPageWrapper = styled.div`
  padding: 25px;
`;

export { MatchPredictionsPageWrapper };
